import {
  ApiErrorCodes,
  ClientError,
  ClientFileErrorHandler,
  ErrorResponse,
  flattenErrors,
} from '@tribeplatform/gql-client/lib'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { I18nShape } from '../../i18n/types.js'

/**
 * Shows a red notification like error message
 * @param message Second line (description) of the toast message
 */
export const composerError =
  ({ $t }: I18nShape) =>
  (message: string) => {
    toast({
      title: $t({
        id: 'Generics.Error',
        defaultMessage: 'Error',
      }),
      description: message,
      status: 'error',
    })
  }

/**
 * File upload error handler
 * @param error Error object with fileName property
 */
export const fileUploadError: (intl: I18nShape) => ClientFileErrorHandler =
  ({ $t }: I18nShape) =>
  error => {
    toast({
      title: $t(
        {
          id: 'Composer.Errors.UnableToUpload',
          defaultMessage: 'Unable to upload {file_name}',
        },
        {
          file_name: error?.fileName || '',
        },
      ),
      description: error?.message,
      status: 'error',
    })
  }

export const embedErrorMessage =
  ({ $t }: I18nShape) =>
  (error: ClientError): string => {
    const normalizedError: ErrorResponse = flattenErrors(
      error?.response?.errors,
    )?.[0]

    if (normalizedError?.field) {
      return normalizedError?.message
    }

    if (normalizedError?.code === ApiErrorCodes.PARAMETER_VALIDATION_FAILED) {
      return $t({
        id: 'Composer.Composer.EmbedPrivateLinkError',
        defaultMessage: 'Cannot upload private or restricted documents',
      })
    }

    return $t({
      id: 'Composer.Composer.BadEmebdLinkError',
      defaultMessage: 'Cannot embed this link',
    })
  }
